var _style, _g, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _g4, _g5, _g6, _g7, _path8, _defs, _rect, _defs2, _rect2, _g8, _rect3, _g9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAmaco = function SvgAmaco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 370 200",
    style: {
      enableBackground: "new 0 0 370 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#013E47;}\n\t.st2{fill:#D5EEEF;}\n\t.st3{fill:#B8E4F3;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#EB2B8F;}\n\t.st6{fill:#020202;}\n\t.st7{fill:url(#SVGID_1_);}\n\t.st8{fill:url(#SVGID_2_);}\n\t.st9{fill:#A97D51;}\n\t.st10{fill:#32BCAF;}\n\t.st11{fill:#093141;}\n\t.st12{fill:#123748;}\n\t.st13{fill:#BFE8FB;}\n\t.st14{opacity:0.2;fill:url(#SVGID_4_);enable-background:new    ;}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#EB2B8F;}\n\t.st16{clip-path:url(#SVGID_6_);fill:url(#SVGID_7_);}\n\t.st17{clip-path:url(#SVGID_9_);fill:url(#SVGID_10_);}\n\t.st18{fill:#070707;}\n")), /*#__PURE__*/React.createElement("pattern", {
    width: 19,
    height: 19,
    patternUnits: "userSpaceOnUse",
    id: "SVGID_3_",
    viewBox: "0 -19 19 19",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: -19,
    className: "st0",
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: -19,
    className: "st0",
    width: 19,
    height: 19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.8,0L0-15.8v1.6L14.2,0H15.8z M9.5,0L0-9.5v4.7L4.7,0H9.5z M19-9.5L9.5-19H4.7L19-4.8V-9.5z M19-14.3 v-1.6L15.8-19h-1.6L19-14.3z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M354.8,188.6c-2.1,3.9-4.6,7.7-7.6,11H40.8c-2.4-2.5-4.6-5.4-6.6-8.6c-2.8-4.3-5.4-8.5-7.6-13.2 c-15.9-33.3-6.1-80.8,36.3-87c15.6-2.4,31.9-1.5,46.8-7.1c19.8-7.4,26.3-25.6,39-40.6c9.3-11,21.9-19.8,36-23.3 c26.2-6.6,52.9,7.4,67.7,28.9c7.7,11.2,13.6,23.6,21.8,34.5c22.5,30.1,87.2,26.5,89.2,72C363.9,166.7,360.4,178.4,354.8,188.6z"
  })), /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.1,199.3l-96.4-0.2c-4.9,0-8.8-4-8.8-8.8l0.2-140.9c0-4.9,4-8.8,8.8-8.8l96.4,0.2 c4.9,0,8.8,4,8.8,8.8L325,190.5C325,195.4,321,199.3,316.1,199.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M313.2,191.8l-90.6-0.2c-2.9,0-5.2-2.3-5.2-5.2l0.2-133c0-2.9,2.3-5.2,5.2-5.2l90.6,0.2 c2.9,0,5.2,2.3,5.2,5.2l-0.2,133C318.5,189.5,316.1,191.8,313.2,191.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M297.6,39.8v4.9l-58.1-0.1v-4.9c0-4.2,3.4-7.7,7.7-7.7h16.5v0.1c0,2.7,2.2,4.9,4.8,4.9 c2.7,0,4.9-2.2,4.9-4.8v-0.1h16.5C294.1,32.1,297.6,35.6,297.6,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.5,22c-5.6,0-10.1,4.5-10.2,10v0.1c0,5.6,4.5,10.2,10.1,10.2s10.2-4.5,10.2-10.1v-0.1 C278.6,26.5,274.1,22,268.5,22z M268.5,37c-2.7,0-4.9-2.2-4.8-4.9V32c0.1-2.6,2.2-4.7,4.9-4.7c2.6,0,4.8,2.1,4.8,4.8v0.1 C273.4,34.9,271.2,37,268.5,37z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 266.5,
    y: 13.6,
    transform: "matrix(1.707055e-03 -1 1 1.707055e-03 225.4939 311.1075)",
    className: "st5",
    width: 4.2,
    height: 58.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.5,112.2h-11.9c-0.9,0-1.6-0.7-1.6-1.6V98.7c0-0.9,0.7-1.6,1.6-1.6h11.9c0.9,0,1.6,0.7,1.6,1.6 v11.9C242.1,111.5,241.4,112.2,240.5,112.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.2,103.3l-51.5-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l51.5,0.1c1.7,0,3,1.4,3,3l0,0 C309.2,101.9,307.8,103.3,306.2,103.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.7,111.8l-31-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l31,0.1c1.7,0,3,1.4,3,3l0,0 C288.7,110.5,287.4,111.8,285.7,111.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.5,143h-11.9c-0.9,0-1.6-0.7-1.6-1.6v-11.9c0-0.9,0.7-1.6,1.6-1.6h11.9c0.9,0,1.6,0.7,1.6,1.6v11.9 C242.1,142.2,241.4,143,240.5,143z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.1,134l-51.5-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l51.5,0.1c1.7,0,3,1.4,3,3l0,0 C309.1,132.7,307.8,134,306.1,134z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.6,142.5l-31-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l31,0.1c1.7,0,3,1.4,3,3l0,0 C288.7,141.2,287.3,142.5,285.6,142.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.4,173.7h-11.9c-0.9,0-1.6-0.7-1.6-1.6v-11.9c0-0.9,0.7-1.6,1.6-1.6h11.9c0.9,0,1.6,0.7,1.6,1.6 v11.9C242,173,241.3,173.7,240.4,173.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.1,164.8l-51.5-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l51.5,0.1c1.7,0,3,1.4,3,3l0,0 C309.1,163.4,307.7,164.8,306.1,164.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.6,173.3l-31-0.1c-1.7,0-3-1.4-3-3l0,0c0-1.7,1.4-3,3-3l31,0.1c1.7,0,3,1.4,3,3l0,0 C288.6,171.9,287.3,173.3,285.6,173.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234,110.3l-7.3-5.6c-0.6-0.4-0.7-1.2-0.2-1.8l0,0c0.4-0.6,1.2-0.7,1.8-0.2l5.5,4.2l8.2-9 c0.5-0.5,1.3-0.6,1.8-0.1l0,0c0.5,0.5,0.6,1.3,0.1,1.8L234,110.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234,141.4l-7.3-5.6c-0.6-0.4-0.7-1.2-0.2-1.8l0,0c0.4-0.6,1.2-0.7,1.8-0.2l5.5,4.2l8.2-9 c0.5-0.5,1.3-0.6,1.8-0.1l0,0c0.5,0.5,0.6,1.3,0.1,1.8L234,141.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M234,171.4l-7.3-5.6c-0.6-0.4-0.7-1.2-0.2-1.8l0,0c0.4-0.6,1.2-0.7,1.8-0.2l5.5,4.2l8.2-9 c0.5-0.5,1.3-0.6,1.8-0.1l0,0c0.5,0.5,0.6,1.3,0.1,1.8L234,171.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.2,
    y: 2.4,
    className: "st6",
    width: 1.5,
    height: 179.7
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M107,15.8L107,15.8c-1.2,0-2.2-1-2.2-2.2V3.1c0-1.2,1-2.2,2.2-2.2l0,0c1.2,0,2.2,1,2.2,2.2v10.5 C109.1,14.8,108.2,15.8,107,15.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.3887,
    y1: 174.6765,
    x2: 67.7854,
    y2: 135.8788,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#54C9EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9852,
    style: {
      stopColor: "#87D4EE"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.8,10.2c-0.5,0.7-17.1,24.6-20.2,65.3l0,0c-5.3-6.2-12.8-9.4-20.3-9.4s-15,3.1-20.3,9.4 C58.1,25.9,106,10.5,106.8,10.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.044,
    y1: 138.9332,
    x2: 111.8483,
    y2: 163.575,
    gradientTransform: "matrix(1 0 0 -1 0 202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0147783,
    style: {
      stopColor: "#87D4EE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54C9EA"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M107,10.2c0.7,0.2,48.7,15.6,60.8,65.3c-10.6-12.5-30-12.5-40.6,0C124.1,34.8,107.5,11,107,10.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.8,10.2c-0.7,0.2-48.7,15.6-60.8,65.3l0,0l0,0C35.3,63.1,16.1,63,5.5,75.3 C23.1,37,61.8,10.3,106.8,10.2L106.8,10.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107,10.2c0.5,0.7,17.1,24.6,20.2,65.3l0,0c-5.3-6.2-12.8-9.4-20.3-9.4s-15,3.1-20.3,9.4 c3.1-40.7,19.7-64.5,20.2-65.3l0,0C106.8,10.2,106.9,10.2,107,10.2C106.9,10.2,106.9,10.2,107,10.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M167.8,75.5L167.8,75.5L167.8,75.5c-12.2-49.6-60.1-65-60.9-65.2l0,0c45,0,83.9,26.7,101.5,65.1v0.2l0,0 C197.8,63,178.5,63,167.8,75.5z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M340.3,88.5v6.1c0,0-1.3,0.8-4.3,0.8c-1.6,0-2-0.8-2-0.8v-2.3L340.3,88.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M341.1,83.9c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1,0,0.2c0.1,3.6-2.2,7.5-5.7,8c0,0,0,0-0.1,0h-0.1 c-0.8,0.1-3.5,0.3-4.5-0.8c-1.2-1.3-2.2-3.6-2.2-5.3c0-1.6,0.3-2,0.3-2.6c0-0.5-0.3-2.1-0.3-2.8c0-3.2,2.2-6.5,6-6.5 C340.3,74.9,341.2,80,341.1,83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M334,94.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M354.7,118.8c-1.9,0.8-7.5-9.9-9.6-14.6s-2.8-8.8-0.5-9.7c2.3-1,4.7,2.5,6.5,7.2 C353,106.5,356.6,118,354.7,118.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M343.9,138.5c-1.7-0.8,3.5-13.2,5.1-16.7s3.5-7,5.4-6.1s0.4,4.6-1.1,8.1 C351.7,127.2,345.6,139.2,343.9,138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M345.3,135.3c2,0.8,0.3,4.2-0.3,5.3c-1,1.9-3.9,2.8-4.7,2.4c-0.7-0.4,1.9-4.4,1.8-4.7 c-0.1-0.2-1.3,2.1-2,1.6c-0.6-0.4,1-3.2,2-4C343.3,135.1,344,134.8,345.3,135.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M334.9,131.7c1.9,0.1,3.6,2.6,3.8,5.2c0.1,2.1,0.1,4.9-0.4,8.4c-1.3,8.5-1.1,19.4-3.6,20.1 c-2.5,0.7-5.2-5.3-5.1-14.1c0.1-8-0.8-18.2,0.9-19.2C331.4,131.6,333.3,131.6,334.9,131.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M332.7,163.3c7.1-2.2,3.9,22.9,1.5,29s-3.3-0.9-3.7-11.4C330,170.3,329.9,164.1,332.7,163.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M344.1,131.7c1.9,0.1,3.6,2.6,3.8,5.2c0.1,2.1,0.1,4.9-0.4,8.4c-1.3,8.5-1.1,19.4-3.6,20.1 c-2.5,0.7-5.2-5.3-5.1-14.1c0.1-8-0.8-18.2,0.9-19.2C340.6,131.6,342.5,131.6,344.1,131.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M341.9,163.3c7.1-2.2,3.9,22.9,1.5,29s-3.3-0.9-3.7-11.4C339.2,170.3,339.1,164.1,341.9,163.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.6,95.1c-1.2,1.1-2.2,3.2-2.4,7.3c-0.1,1.1-0.9,4.3,0.6,8.1c2.4,5.9,0,18.2-0.6,21.1 c-0.1,0.3,0.2,0.6,0.5,0.6l20.5,0.4c0.6,0,1.1-0.5,1-1.1c-0.3-4.1-1.4-18.1-0.9-21.5c1.9-11.9,0-15.7-3.3-16.6 C340,92,330.8,93.9,329.6,95.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "338.9,145.6 339.7,180.8 345.6,180.7 347.2,146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "329.7,145.6 330.6,180.8 336.5,180.7 338,146  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M349.1,131.9l0.7,31.8c0,0-8.7,1.1-11.6,1c-5.2-0.1-11.4-0.9-11.4-0.9l0.7-32.1L349.1,131.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M307.3,103.5c1.2-1.4,11.6,7.1,14.4,9.6s5.6,5.3,4.3,6.9c-1.3,1.5-4.5-0.9-7.4-3.4 C315.8,114.1,306.1,104.9,307.3,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M325,120.4c-2-0.5-0.1-12.3,1.1-17.3c1.2-4.9,3-8.6,5.4-8s2.2,4.7,0.9,9.6 C331.1,109.7,327,120.9,325,120.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M303.6,99.4c0.5-0.5,3.1,2,3.9,2.7c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0-0.1c-0.1-0.4-1.2-1.8-0.7-2.3 s2.6,1.4,3.3,2.7c0,0.1,0.1,0.1,0.1,0.2c0.6,1.2,0.7,2-0.1,3.1c-1.2,1.8-4.1-0.7-5.1-1.6c-0.8-0.7-1.4-1.9-1.7-2.8 C303.4,100.5,303.3,99.7,303.6,99.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M327.4,79.4c0,0.2,0.1,0.4,0.1,0.6c0.2,0.9,0.8,1.6,1.1,2.4c0.4,1,0.5,2,0.6,3.1c0.4,2.5,0.7,5,0.9,7.5 c0.1,1.9-0.3,3.7,0.4,5.5c0.9,2.4,2.7,5.1,4.5,6.9c1.7,1.6,3.8,2.5,6.1,2.3c2.6-0.3,5.1-1.9,6.4-4.2c1.3-2.3,2-5,1.8-7.7 c-0.3-3.7-2-7.2-4.4-10.2c-0.8-1-1.7-2-2.2-3.2c-0.6-1.3-0.4-2.8-0.7-4.2c-0.4-1.4-1.1-2.6-2.3-3.4c-2.3-1.6-5.4-1.4-7.9-0.6 C329.3,75,327,76.5,327.4,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M331.3,192.2c0,0-1,1.1-3.3,2.5s-2.9,1.1-2.9,1.7c-0.1,0.5,9.5,0.1,9.5,0.1l-0.1-4.4 C334.4,192,331.3,192,331.3,192.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M340.6,192.1c0,0-0.5,1.3-2.1,2.8c-1.4,1.3-1.9,1-1.8,1.5s7,0.2,7,0.2l-0.2-4.6 C343.5,192,340.6,192,340.6,192.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M65.7,147.2L65.7,147.2c0.1,0,1.8-0.3,3.4-1.2l0,0v2.4c0,0-0.5,2.3-3.3,2.9c-2.8-0.6-3.3-2.9-3.3-2.9 v-2.2l0,0C64.2,147,65.7,147.2,65.7,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M65.8,147.2L65.8,147.2c-0.1,0-1.6-0.2-3.1-1c-1.5-0.7-3-2-3.3-4c0,0-1.7-0.7-1.7-2.1 c0-1.4,1.5-1,1.5-1s-1.2-4.4,1.1-7.6c2.3-3.3,5.3-2.2,5.3-2.2h0.2c0,0,3-1,5.3,2.2s1.1,7.6,1.1,7.6s1.5-0.4,1.5,1 s-1.7,2.1-1.7,2.1c-0.3,1.9-1.6,3.1-3,3.8C67.5,147,65.8,147.2,65.8,147.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.1,182.1L80.1,182.1c-6.6,2.7-13.6,6.9-14.2,7.3c-0.6-0.4-7.6-4.6-14.2-7.2v-0.1v-6.2v-3.6h1.5h12.6 H66h12.6h1.5v3.6V182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M51.7,182.1L51.7,182.1c-1.3-0.4-2.5-0.8-3.7-1.2c-3-2.4-7.1-5.9-7.5-7.5c-0.4-1.2,1.2-4.7,3.3-8.5l0,0 l6.7,3.8c-0.9,1.6-1.7,3.2-1.5,3.6c0.3,0.9,2.7,3.5,2.7,3.5l0,0V182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M80.1,182.1v-6.2l0,0c0,0,2.4-2.6,2.7-3.5c0.1-0.4-0.6-2-1.5-3.6L88,165l0,0c2,3.8,3.6,7.3,3.3,8.5 c-0.5,1.5-4.5,5-7.5,7.4C82.6,181.2,81.4,181.6,80.1,182.1L80.1,182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M65.8,172.3H53.2V172c0.1-2.5-0.2-7.7-0.2-7.7s-1.4,2.3-2.6,4.4l-6.7-3.8l0,0c2.1-3.9,4.6-8.2,6-10.7 c2.6-4.9,12.9-5.8,12.9-5.8s0.5,2.3,3.3,2.9c2.8-0.6,3.3-2.9,3.3-2.9s10.3,1,12.9,5.8c1.3,2.5,3.9,6.7,6,10.7l0,0l-6.7,3.8 c-1.2-2.1-2.6-4.4-2.6-4.4s-0.3,5.2-0.2,7.7v0.2H66h-0.2V172.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M58.3,137.3c-0.1-0.1-0.5-0.7-0.4-1.5c0.1-1.1,0.8-1.6,0.8-1.7c0-0.1-0.2-0.4-0.1-0.9 c0.1-0.4,0.4-0.7,0.7-0.7c0-0.1-0.3-1,0.2-1.8c0.4-0.7,1.2-1,1.9-0.7c0.1-0.9,0.5-1.7,1.2-2c0.9-0.5,1.8,0.1,1.9,0.2 c0,0,0.2-0.5,0.6-0.6c0.3-0.1,0.6,0.1,0.8,0.4c0.2-0.3,0.5-0.4,0.8-0.4c0.5,0.1,0.6,0.6,0.6,0.6c0.1-0.1,0.9-0.7,1.9-0.2 c0.7,0.4,1.1,1.1,1.2,2c0.7-0.3,1.5,0,1.9,0.7c0.5,0.8,0.2,1.7,0.2,1.8c0.3,0.1,0.6,0.4,0.7,0.7c0.1,0.4,0,0.8-0.1,0.9 c0.1,0.1,0.8,0.6,0.8,1.7c0,0.8-0.3,1.4-0.4,1.5c0.3,0.2,0.4,0.6,0.3,1s-0.4,0.6-0.7,0.6c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3-0.2-0.5-0.4c-0.3-0.6-0.1-1.2,0-1.3c-0.1-0.1-0.7-0.9-0.6-1.9c0-0.2,0.1-0.4,0.2-0.6 c-0.1-0.1-0.9-0.4-1.1-1.3c-0.1-0.3-0.1-0.5-0.1-0.7c-0.2,0.2-0.5,0.2-0.7,0c-0.2-0.1-0.2-0.3-0.3-0.4 c-0.2,0.1-0.6,0.3-1.2,0.3c-0.6-0.1-1-0.4-1.2-0.6c0,0-0.2,0.6-1.1,0.6l0,0l0,0l0,0l0,0c-0.9,0-1.1-0.6-1.1-0.6 c-0.1,0.1-0.6,0.5-1.2,0.6s-1-0.2-1.2-0.3c0,0.1-0.1,0.3-0.3,0.4c-0.2,0.2-0.5,0.2-0.7,0c0,0.2,0,0.4-0.1,0.7 c-0.2,0.9-1,1.2-1.1,1.3c0.1,0.2,0.1,0.4,0.2,0.6c0.1,1-0.5,1.8-0.6,1.9c0,0,0.3,0.7,0,1.3c-0.2,0.3-0.4,0.4-0.5,0.4 s-0.2,0-0.3-0.1s-0.3-0.2-0.3-0.3c-0.3,0-0.6-0.2-0.7-0.6C57.9,138,58.1,137.6,58.3,137.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M78.1,198.9c0,0-34.1-3-37.6-10.5c-2.5-5.5,2.9-9.9,9.1-7.7s28.6,13.1,28.6,13.1L78.1,198.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M80.2,194.8v4.4c0,0,5.8,0.4,6.2-0.3c0.4-0.7,0.8-3-0.7-4.1C84.3,193.7,80.7,193.6,80.2,194.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78,193.9 80.3,194.8 80.3,199.2 77.9,198.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M53.7,198.9c0,0,34.1-3,37.6-10.5c2.5-5.5-2.9-9.9-9.1-7.7s-28.6,13.1-28.6,13.1L53.7,198.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "53.7,193.9 51.4,194.8 51.4,199.2 53.8,198.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M51.5,194.8v4.4c0,0-5.8,0.4-6.2-0.3s-0.8-3,0.7-4.1C47.4,193.7,51,193.6,51.5,194.8z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M286.7,194.6l-0.3-0.2c-23.9-10-24.4-45.4-24.4-47v-1.1l24.7-8.7l0.5-0.2l25.2,8.9v1.1 c0,1.5-0.6,37.1-24.6,47l-0.3,0.1L286.7,194.6L286.7,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.3,175.1c-6,0-11-4.7-11.3-10.7c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.3c0-0.3,0-0.5,0-0.8h6.1l0.6,1.4 l2.9,6.9c0.3,0.7,0.9,1.1,1.7,1.1h0.1c0.8,0,1.4-0.4,1.7-1.1l3.4-7l0.7-1.4h7.6v-0.4c0-0.5-0.1-1-0.2-1.4 c-0.1-0.5-0.2-1-0.4-1.4c0-0.1-0.1-0.2-0.1-0.3c-1.9-5.5-7-9.2-12.8-9.2s-10.9,3.7-12.8,9.2h2.3c1.8-4.2,5.9-7,10.5-7 s8.7,2.8,10.5,7c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.3,0.2,0.6,0.3,0.9h-5.2c-0.7,0-1.4,0.4-1.7,1.1l-1.2,2.5l-2.7,5.6l-2.4-5.6 l-1-2.5c-0.3-0.7-1-1.1-1.8-1.1h-8.1l-0.1,0.3c-0.1,0.5-0.2,1-0.2,1.4s-0.1,0.8-0.1,1.2c0,0.1,0,0.2,0,0.3s0,0.3,0,0.4 c0.2,3.4,1.6,6.6,4,8.9c2.5,2.5,5.9,3.9,9.4,3.9c3.6,0,6.9-1.4,9.4-3.9c2.4-2.4,3.9-5.6,4-8.9h-2.2 C298.3,170.4,293.3,175.1,287.3,175.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M287.2,139.1l23.6,8.3c0,0-0.3,35.9-23.6,45.5l0,0c0,0,0,0-0.1,0c-23.2-9.7-23.5-45.5-23.5-45.5 L287.2,139.1L287.2,139.1 M287.2,135.7l-1,0.4h-0.1l0,0l0,0l-23.5,8.3l-2.2,0.8v2.3c0,1.5,0.6,37.8,25.2,48.4l0.6,0.4h1h0.6 l0.6-0.2c25-10.4,25.6-46.9,25.6-48.5v-2.3l-2.2-0.8l-23.6-8.3L287.2,135.7L287.2,135.7z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230.8,116.4c-3.3,1.2-2.3,5.9-2.3,5.9c-1.9,1-4.2-0.8-4.2-0.8l0,0c0.8,1.6,1.4,2.8,1.8,3.2 c0.6,0.5,1.7,1.5,3.1,2.7c0.2,0.2,0.4,0.4,0.6,0.5c2.9-1.6,4.2-1.3,9-1.6c4.9-0.3,6.8,0.5,6.8-5.8 C245.5,114.1,234.1,115.2,230.8,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M229.8,128c0,0-0.1,0-0.1,0.1l-0.5-0.6C229.3,127.6,229.5,127.8,229.8,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M237.9,183.6v13c0,1.5-1.2,2.7-2.7,2.7h-11.3c-1.5,0-2.7-1.2-2.7-2.7v-10.9h12.5c1.9,0,3.5-1.1,4.3-2.7 C237.9,183.2,237.9,183.4,237.9,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M232.6,132.7c0,0,5.2,3,3.4,12c0,0-18.9,5.6-31.9,4.7l0,0c3.8-3.8,5.3-9,5.6-10.1c0-0.1,0-0.2,0-0.2 C225.1,137.8,232.6,132.7,232.6,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M230.7,165.6c0.2,1.6-0.1,4.8-2.8,7.2s-14.2,2.5-14.2,2.5c-4.7-5.2-4.5-9.4-4.5-9.4l0,0L230.7,165.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.7,116.4c3.3,1.2,2.3,5.9,2.3,5.9c1.9,1,4.2-0.8,4.2-0.8l0,0c-0.8,1.6-1.4,2.8-1.8,3.2 c-0.6,0.5-1.7,1.5-3.1,2.7c-0.2,0.2-0.4,0.4-0.6,0.5c-2.9-1.6-4.2-1.3-9-1.6c-4.9-0.3-6.8,0.5-6.8-5.8 C89.9,114.1,101.4,115.2,104.7,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M105.7,128c0,0,0.1,0,0.1,0.1l0.5-0.6C106.1,127.6,105.9,127.8,105.7,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M167.7,127.4c52.4,0,58.3-2.7,58.3-2.7c-0.4-0.4-1-1.5-1.8-3.2c-3.4-7.2-9.9-23.9-12.6-26.6 c-3.3-3.3-43.6-4.1-43.9-4.1l0,0l0,0l0,0l0,0c-0.3,0-40.7,0.8-43.9,4.1c-2.7,2.7-9.2,19.4-12.6,26.6 c-0.8,1.6-1.4,2.8-1.8,3.2C109.4,124.7,115.3,127.4,167.7,127.4L167.7,127.4L167.7,127.4L167.7,127.4L167.7,127.4z  M115.5,121.2c-0.4-1,8.1-20.8,10.5-23.1c2.3-2.2,41.6-3.3,41.7-3.3c0.1,0,39.4,1.1,41.7,3.3c2.4,2.2,10.9,22,10.5,23.1 c-0.4,1-49.1,0.1-52.2,0l0,0l0,0l0,0l0,0C164.6,121.3,115.9,122.2,115.5,121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M97.6,183.6v13c0,1.5,1.2,2.7,2.7,2.7h11.3c1.5,0,2.7-1.2,2.7-2.7v-10.9h-12.5c-1.9,0-3.5-1.1-4.3-2.7 C97.6,183.2,97.6,183.4,97.6,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.8,181.4c-0.8,0.8-2,1.3-3.2,1.3h-12.3h-53.5l0,0h-53.5H102c-1.2,0-2.4-0.5-3.2-1.3 c-0.9-0.9-1.5-2.1-1.5-3.5v3c0,0.8,0.2,1.5,0.5,2.1c0.8,1.6,2.4,2.7,4.3,2.7h12.5H168l0,0h53.4h12.5c1.9,0,3.5-1.1,4.3-2.7 c0.3-0.6,0.5-1.3,0.5-2.1v-3C238.3,179.3,237.7,180.5,236.8,181.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M102.8,132.7c0,0-5.2,3-3.4,12c0,0,18.9,5.6,31.9,4.7l0,0c-3.8-3.8-5.3-9-5.6-10.1c0-0.1,0-0.2,0-0.2 C110.3,137.8,102.8,132.7,102.8,132.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M104.7,165.6c-0.2,1.6,0.1,4.8,2.8,7.2c2.7,2.4,14.2,2.5,14.2,2.5c4.7-5.2,4.5-9.4,4.5-9.4l0,0 L104.7,165.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M209.4,98.1c-2.3-2.2-41.5-3.3-41.7-3.3l0,0l0,0l0,0l0,0c-0.2,0-39.4,1.1-41.7,3.3 c-2.4,2.2-10.9,22-10.5,23.1c0.4,1,49.1,0.1,52.2,0c3.1,0.1,51.8,1,52.2,0C220.3,120.2,211.8,100.4,209.4,98.1z"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_4_",
    xlinkHref: "#SVGID_3_",
    patternTransform: "matrix(9.9242 0 0 -9.9242 138033.4375 -156731.7031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M209.4,98.1c-2.3-2.2-41.5-3.3-41.7-3.3l0,0l0,0l0,0l0,0c-0.2,0-39.4,1.1-41.7,3.3 c-2.4,2.2-10.9,22-10.5,23.1c0.4,1,49.1,0.1,52.2,0c3.1,0.1,51.8,1,52.2,0C220.3,120.2,211.8,100.4,209.4,98.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M238.3,138.2c0-1.8-0.8-3.6-2.2-4.8c-1.8-1.5-4.2-3.6-6.4-5.5c0,0-0.1,0-0.1,0.1l-0.5-0.6 c-1.4-1.2-2.5-2.2-3.1-2.7c0,0-5.9,2.7-58.3,2.7s-58.4-2.7-58.4-2.7c-0.6,0.5-1.7,1.5-3.1,2.7l-0.5,0.6c0,0-0.1,0-0.1-0.1 c-2.1,1.8-4.6,4-6.4,5.5c-1.4,1.2-2.2,2.9-2.2,4.8v18.6v21.1c0,1.4,0.6,2.6,1.5,3.5c0.8,0.8,2,1.3,3.2,1.3H114h53.5l0,0H221 h12.3c1.2,0,2.4-0.5,3.2-1.3c0.9-0.9,1.5-2.1,1.5-3.5v-21.1l0,0v-18.6H238.3z M209.9,139.3c0-0.1,0-0.2,0-0.2 c15.2-1.3,22.7-6.4,22.7-6.4s5.2,3,3.4,12c0,0-18.9,5.6-31.9,4.7l0,0C208,145.5,209.6,140.3,209.9,139.3z M102.8,132.7 c0,0,7.5,5.1,22.7,6.4c0,0,0,0.1,0,0.2c0.3,1,1.9,6.2,5.6,10.1l0,0c-13,0.9-31.9-4.7-31.9-4.7 C97.6,135.7,102.8,132.7,102.8,132.7z M121.7,175.3c0,0-11.5-0.1-14.2-2.5s-3-5.6-2.8-7.2l21.5,0.2l0,0 C126.2,165.9,126.4,170.1,121.7,175.3z M176,161.7c0.9,0,1.9,0,3,0C178,161.7,177,161.7,176,161.7z M182.4,161.8 c0.4,0,0.8,0,1.2,0C183.2,161.8,182.8,161.8,182.4,161.8z M227.9,172.8c-2.7,2.4-14.2,2.5-14.2,2.5c-4.7-5.2-4.5-9.4-4.5-9.4 l0,0l21.5-0.2C230.9,167.2,230.6,170.4,227.9,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M190.6,149.1h-45.8c-2.1,0-3.8-1.7-3.8-3.8l0,0c0-2.1,1.7-3.8,3.8-3.8h45.8c2.1,0,3.8,1.7,3.8,3.8l0,0 C194.5,147.4,192.7,149.1,190.6,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M193,178.5h-50.6c-4.4,0-7.9-3.5-7.9-7.9v-3.7c0-1.1,0.9-2,2-2h62.3c1.1,0,2,0.9,2,2v3.7 C200.9,174.9,197.4,178.5,193,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M185.2,174.6h-35c-0.9,0-1.6-0.7-1.6-1.6v-1.6c0-0.9,0.7-1.6,1.6-1.6h35c0.9,0,1.6,0.7,1.6,1.6v1.6 C186.9,173.9,186.1,174.6,185.2,174.6z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M235.1,75.4c6.7-12.2,19.5-20.6,34.3-20.8c0-0.6,0.3-4.8,0.6-4.8c0.3,0,0.5,4.7,0.5,4.7l0,0 c14.7,0.1,27.5,8.2,34.3,20.2c-1.7-1.5-4-2.4-6.5-2.4c-2.7,0-5.1,1-6.9,2.7c-1.8-1.7-4.2-2.7-6.9-2.7c-2.8,0-5.3,1.1-7.1,3 c-1.8-1.8-4.3-3-7.1-3c-2.9,0-5.4,1.2-7.3,3.1c-1.8-1.9-4.4-3.1-7.3-3.1c-2.6,0-4.9,1-6.7,2.6c-1.8-1.6-2.6-2.6-6.7-2.6 C240.4,72.4,237.7,73.6,235.1,75.4"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M248.8,74.1c0,0.2,0,0.5,0,0.7l0.1,0.1c1.8-1.6,4.1-2.6,6.7-2.6c2.9,0,5.4,1.2,7.3,3.1 c1.8-1.9,4.4-3.1,7.3-3.1c2.8,0,5.3,1.1,7.1,3c1.8-1.8,4.3-3,7.1-3c2.6,0,5.1,1,6.8,2.7c0-0.3,0-0.6,0-0.9 c0-10.8-9.5-19.6-21.2-19.6C258.3,54.5,248.8,63.3,248.8,74.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -236.3428,
    y1: 403.0383,
    x2: -235.7851,
    y2: 403.0383,
    gradientTransform: "matrix(76.2014 0 0 -37.5856 18258.4531 15213.4561)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03138082,
    style: {
      stopColor: "#FDF3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08854853,
    style: {
      stopColor: "#FAD9E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    style: {
      stopColor: "#F4B0CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2575,
    style: {
      stopColor: "#EE79AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#E8168B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#E92D8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    style: {
      stopColor: "#EF86B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 248.8,
    y: 54.5,
    className: "st16",
    width: 42.5,
    height: 21
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    d: "M262.9,74.2c0,0.4,0,0.9,0,1.3c1.8-1.9,4.4-3,7.2-3c2.7,0,5.2,1.1,7,2.9c0-0.4,0-0.8,0-1.1 c0-10.8-3.2-19.6-7.1-19.6C266.1,54.6,262.9,63.4,262.9,74.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -241.4314,
    y1: 403.0515,
    x2: -240.8737,
    y2: 403.0515,
    gradientTransform: "matrix(25.5823 0 0 -37.4984 6439.2842 15178.835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04572634,
    style: {
      stopColor: "#FDF3F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    style: {
      stopColor: "#FAD9E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2405,
    style: {
      stopColor: "#F4B0CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3752,
    style: {
      stopColor: "#EE79AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#E8168B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7466,
    style: {
      stopColor: "#F29DC1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9213,
    style: {
      stopColor: "#FBE1EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 262.9,
    y: 54.6,
    className: "st17",
    width: 14.3,
    height: 20.9
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M297.1,78.7c0,0.6,0.2,1,0.6,1.3c0.4,0.3,0.9,0.4,1.5,0.4c0.6,0,1.1-0.1,1.5-0.4c0.4-0.3,0.6-0.7,0.6-1.3 c0-0.6-0.2-1-0.6-1.3c-0.4-0.3-0.9-0.4-1.5-0.4c-0.6,0-1.1,0.1-1.5,0.4C297.3,77.7,297.1,78.1,297.1,78.7 M295.6,78.7 c0-0.5,0.1-1,0.3-1.3c0.2-0.3,0.4-0.5,0.7-0.7c0.3-0.2,0.6-0.4,1-0.5c0.5-0.1,1-0.2,1.6-0.2c1.1,0,2,0.2,2.6,0.7 c0.7,0.5,1,1.1,1,1.9c0,0.8-0.3,1.5-1,1.9c-0.7,0.5-1.5,0.7-2.6,0.7c-1.1,0-2-0.2-2.6-0.7C295.9,80.1,295.6,79.5,295.6,78.7  M286.5,79.3l1.5,0.3c-0.2,0.6-0.6,1-1.1,1.2c-0.5,0.3-1.2,0.4-2,0.4c-1,0-1.8-0.2-2.4-0.7c-0.6-0.5-1-1.1-1-1.9 c0-0.8,0.3-1.5,1-2c0.6-0.5,1.5-0.7,2.5-0.7c0.9,0,1.7,0.2,2.2,0.5c0.3,0.2,0.6,0.5,0.8,0.9l-1.5,0.2c-0.1-0.3-0.3-0.5-0.6-0.6 c-0.3-0.2-0.6-0.2-1-0.2c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.5,0.7-0.5,1.3c0,0.6,0.2,1.1,0.5,1.4c0.3,0.3,0.8,0.4,1.3,0.4 c0.4,0,0.7-0.1,1-0.3C286.1,80,286.4,79.7,286.5,79.3 M271.5,79.2l-1-1.9l-1,1.9H271.5z M274.3,81.2h-1.6l-0.6-1.2h-3l-0.6,1.2 h-1.6l2.9-5.1h1.6L274.3,81.2z M252.2,81.2v-5.1h2.3l1.4,3.5l1.3-3.5h2.3v5.1H258v-4l-1.5,4h-1.5l-1.5-4v4H252.2z M242,79.2 l-1-1.9l-1,1.9H242z M244.8,81.2h-1.6l-0.7-1.2h-3l-0.6,1.2h-1.6l2.9-5.1h1.6L244.8,81.2z"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 235.2,
    y: 82.8,
    className: "st15",
    width: 70.8,
    height: 1
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M237.8,91.8v-5h1v5H237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M242.6,91.8v-5h1l2.1,3.4v-3.4h0.9v5h-1l-2-3.3v3.3H242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M250.2,90.1l1-0.1c0.1,0.3,0.2,0.6,0.4,0.7c0.2,0.2,0.4,0.2,0.7,0.2c0.3,0,0.6-0.1,0.7-0.2 c0.2-0.1,0.2-0.3,0.2-0.5c0-0.1,0-0.2-0.1-0.3c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.4-0.1-0.8-0.2c-0.5-0.1-0.9-0.3-1.2-0.5 c-0.3-0.3-0.5-0.6-0.5-1c0-0.3,0.1-0.5,0.2-0.7c0.1-0.2,0.4-0.4,0.6-0.5c0.3-0.1,0.6-0.2,1-0.2c0.6,0,1.1,0.1,1.4,0.4 c0.3,0.3,0.5,0.6,0.5,1.1l-1,0c0-0.3-0.1-0.4-0.3-0.6c-0.1-0.1-0.4-0.2-0.6-0.2c-0.3,0-0.5,0.1-0.7,0.2c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.4,0.2,0.9,0.3c0.5,0.1,0.9,0.2,1.1,0.4c0.2,0.1,0.4,0.3,0.6,0.5c0.1,0.2,0.2,0.5,0.2,0.8 c0,0.3-0.1,0.6-0.2,0.8c-0.2,0.3-0.4,0.4-0.7,0.6c-0.3,0.1-0.7,0.2-1.1,0.2c-0.6,0-1.1-0.1-1.5-0.4 C250.5,91.1,250.3,90.7,250.2,90.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M258,86.7h1v2.7c0,0.4,0,0.7,0,0.8c0,0.2,0.1,0.4,0.3,0.5c0.2,0.1,0.4,0.2,0.7,0.2c0.3,0,0.5-0.1,0.7-0.2 c0.1-0.1,0.2-0.3,0.3-0.4c0-0.2,0-0.5,0-0.9v-2.8h1v2.7c0,0.6,0,1-0.1,1.3c-0.1,0.3-0.2,0.5-0.3,0.6c-0.1,0.2-0.3,0.3-0.6,0.4 c-0.2,0.1-0.6,0.2-1,0.2c-0.5,0-0.8-0.1-1.1-0.2c-0.2-0.1-0.4-0.3-0.6-0.4c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.3-0.1-0.7-0.1-1.3 V86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M265.9,91.8v-5h2.1c0.5,0,0.9,0,1.2,0.1c0.2,0.1,0.4,0.3,0.6,0.5c0.1,0.2,0.2,0.5,0.2,0.8 c0,0.4-0.1,0.7-0.3,0.9c-0.2,0.2-0.6,0.4-1,0.5c0.2,0.1,0.4,0.3,0.5,0.4c0.1,0.2,0.3,0.4,0.6,0.8l0.6,1h-1.2l-0.7-1.1 c-0.3-0.4-0.4-0.6-0.5-0.7c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.3-0.1-0.5-0.1H267v2.1H265.9z M267,88.9h0.8c0.5,0,0.8,0,0.9-0.1 c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.4c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.3,0-0.7,0H267V88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M278.4,91.8h-1.1l-0.4-1.1h-2l-0.4,1.1h-1.1l2-5h1.1L278.4,91.8z M276.5,89.8l-0.7-1.9l-0.7,1.9H276.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M281.8,91.8v-5h1l2.1,3.4v-3.4h0.9v5h-1l-2-3.3v3.3H281.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M292.9,89.9l1,0.3c-0.2,0.6-0.4,1-0.8,1.2c-0.4,0.3-0.8,0.4-1.3,0.4c-0.7,0-1.2-0.2-1.7-0.7 c-0.4-0.5-0.6-1.1-0.6-1.9c0-0.8,0.2-1.5,0.7-2c0.4-0.5,1-0.7,1.7-0.7c0.6,0,1.1,0.2,1.5,0.5c0.2,0.2,0.4,0.5,0.5,0.9l-1,0.2 c-0.1-0.3-0.2-0.5-0.4-0.6c-0.2-0.2-0.4-0.2-0.7-0.2c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.3c0,0.6,0.1,1.1,0.3,1.4 c0.2,0.3,0.5,0.4,0.9,0.4c0.3,0,0.5-0.1,0.7-0.3C292.7,90.6,292.8,90.3,292.9,89.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M297.6,91.8v-5h3.7v0.9h-2.7v1.1h2.5v0.9h-2.5v1.4h2.8v0.9H297.6z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAmaco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/amaco.d9611634.svg";
export { ForwardRef as ReactComponent };